<template v-if="this.view === 'thumbnail'">
    <div id="btn-container" class="no-click-stats">
        <div class="no-click-stats">
            <button class="btn btn-primary positive no-click-stats" @click="getStatistic">
                <div v-if="loading" class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <i v-else class="fa-solid fa-chart-pie main_text disable-click"></i>
                
            </button>
        </div>
        <DocumentsStatistics @modalClosed="deleteData" :files="items" :show="showModal" :media_id="this.file_id" :media_name="this.file_name" :translations="trans('lms.VueDataTables')"/>
    </div>
</template>
<template v-else>
    <span class="no-click-stats">
            <a class="no-click-stats" @click="getStatistic">

                <i class="fa-solid fa-chart-pie main_text disable-click"></i>

            </a>
        <DocumentsStatistics @modalClosed="deleteData" :files="items" :show="showModal" :media_id="this.file_id" :media_name="this.file_name" :translations="trans('lms.VueDataTables')"/>
    </span>
</template>
<script>
import DocumentsStatistics from "./documentsstatistics";

export default {
  props: ["file_id","file_name"],
  components:{
      DocumentsStatistics
  },
  data() {
    return {
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      items: [],
      loading: false,
      showModal: false,
    };
  },
  methods:{
      getStatistic(){
          this.loading = true;
          axios({
            method: 'post',
            url: '/admin/documentstatistics',
            data: {
                _token: this.csrf,
                document_id: this.file_id
            }
        }).then(response => {
            (
                this.items = response.data,
                this.showModal = true,
                this.loading = false
            );
        });
      },
      deleteData(){
          this.items = [];
          this.showModal = false;
          this.loading = false;
      }
  }
};
</script>
<style scoped>
    #btn-container{
        margin: 5px;
    }
    @keyframes spinner-border {
        to { transform: rotate(360deg); }
    }
    .disable-click{
        pointer-events: none;
    }
    .spinner-border {
        top: 2px;
        position: relative;
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: .25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
    }
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0,0,0,0);
        white-space: nowrap;
        border: 0;
    }
    .no-click-stats:hover{
        cursor: pointer;
    }
</style>